import { Component } from "react";
import * as Sentry from "@sentry/react";
import { Props, State } from "./ErrorBoundary.Parts";

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  render() {
    if (this.state.hasError) {
      const err = this.state.error ?? new Error("Unknown error");
      Sentry.captureException(err);
      if (typeof this.props.fallback === "function") {
        return this.props.fallback(err);
      }
      return this.props.fallback;
    }

    return this.props.children;
  }
}
